import { Archive } from "./Archive";

export default Archive;
